import { FC } from "react";
import "./ChatBranding.scss";
import { MarkdownBuilder } from "../MardownBuilder";

export interface ChatBrandingProps {
    readonly text?: string;
}

export const ChatBranding: FC<ChatBrandingProps> = ({ text }: ChatBrandingProps) => {
    const regex = /\[([^\]]+)\]\((https?:\/\/[^\)]+)\)/;

    const match = text?.match(regex);

    return match ? (
        <MarkdownBuilder text={text} applyBrandingClass={true} linkColor="white" />
    ) : (
        <div className="chat-footer__branding" style={{ color: "white" }}>
            {text}
        </div>
    );
};
